import React from 'react';
import PropTypes from 'prop-types';

import './icon-tooltip.scss';

const IconTooltip = ({
    children,
    text,
    icon,
    homeworkColorIdx,
}) => {

    const getTooltipText = () => {
        if (text) {
            return text;
        }

        switch (icon) {
            case 'monitor':
                return 'Доступна презентація';

            case 'pdf':
                return 'Скачати презентацію в PDF';

            case 'list':
                return 'Вордліст';

            case 'youtube':
            case 'video':
                return 'Доступне посилання на відео бонусного заняття';

            case 'book':
                switch (homeworkColorIdx) {
                    case 4:
                        return 'Домашнє завдання виконано';

                    case 2:
                        return 'Домашнє завдання не виконано повністю';

                    case 3:
                        return 'Протерміноване домашнє завдання';

                    default:
                        return 'Домашнє завдання';
                }

            default:
                return null;
        }
    };

    const tooltipText = getTooltipText();

    if (!tooltipText) {
        return children;
    }

    return (
        <div className="icon-tooltip">
            {children}

            <div className="icon-tooltip__text">
                {tooltipText}
            </div>
        </div>
    );
};

IconTooltip.propTypes = {
    children: PropTypes.node.isRequired,
    text: PropTypes.string,
    icon: PropTypes.string,
    homeworkColorIdx: PropTypes.number,
};

export default IconTooltip;